import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { MaskHeading, Reveal } from "./motion";
import { BUSINESS } from "@/config/businessConfig";

export const QuoteCTA = ({ title = ["Got a box", "full of parts?"] }) => (
  <section className="relative bg-[var(--orange)] text-[var(--ink)] overflow-hidden" data-testid="quote-cta-section">
    <svg className="absolute -right-24 -top-24 w-[520px] h-[520px] opacity-[0.12] spin-slow" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M16 1.5 28.6 8.75v14.5L16 30.5 3.4 23.25V8.75Z" fill="none" stroke="#0F1012" strokeWidth="0.6" />
      <circle cx="16" cy="16" r="6" fill="none" stroke="#0F1012" strokeWidth="0.6" />
    </svg>
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28 grid gap-10 lg:grid-cols-12 items-end">
      <div className="lg:col-span-8">
        <p className="font-mono-x text-xs tracking-[0.18em] uppercase mb-5">Free quotes · Woodstock · Ingersoll · Oxford County</p>
        <MaskHeading lines={title.map((t) => ({ text: t }))} className="font-display font-black uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.88] tracking-tight" />
        <p className="mt-6 max-w-xl text-base lg:text-lg font-medium text-[#2a1208]">
          Send us what you bought and a few photos. We'll come back with a clear quote — then show up and build it.
        </p>
      </div>
      <Reveal className="lg:col-span-4 flex flex-col gap-3">
        <Link to="/contact" data-testid="cta-quote-btn" className="group flex items-center justify-between bg-[var(--ink)] text-white px-6 py-5 font-display text-xl font-black uppercase tracking-wide hover:bg-black transition-colors">
          Request a Quote <ArrowUpRight className="w-6 h-6 text-[var(--orange)] transition-transform duration-300 group-hover:rotate-45" />
        </Link>
        <a href={BUSINESS.phoneHref} data-testid="cta-call-btn" className="flex items-center gap-3 border-2 border-[var(--ink)] px-6 py-4 font-display text-lg font-bold uppercase hover:bg-[var(--ink)] hover:text-white transition-colors">
          <Phone className="w-5 h-5" /> Call {BUSINESS.phoneDisplay}
        </a>
        <a href={BUSINESS.emailHref} data-testid="cta-email-btn" className="flex items-center gap-3 border-2 border-[var(--ink)] px-6 py-4 font-display text-lg font-bold uppercase hover:bg-[var(--ink)] hover:text-white transition-colors break-all">
          <Mail className="w-5 h-5 shrink-0" /> {BUSINESS.email}
        </a>
      </Reveal>
    </div>
  </section>
);
